<template>
  <div>
    <h2 class="title is-4 is-main-title">{{ $t('about.title') }}</h2>
    <p v-html="$t('about.text')"></p>
  </div>
</template>

<script>
export default {
  name: 'AboutView',
}
</script>

<style scoped>
.is-main-title{
  margin: 0.55em;
}

.is-main-content p{
  font-size: 14px;
  text-align: justify;
  margin: 1em;
  line-height: 1.4;
}
</style>

